export const CERTIFICATES_LOAD_STARTED = 'CERTIFICATES_LOAD_STARTED';
export const CERTIFICATES_LOAD_FAILED = 'CERTIFICATES_LOAD_FAILED';
export const CERTIFICATES_LOAD_SUCCESS = 'CERTIFICATES_LOAD_SUCCESS';

export const CERTIFICATES_DELETE_STARTED = 'CERTIFICATES_DELETE_STARTED';
export const CERTIFICATES_DELETE_FAILED = 'CERTIFICATES_DELETE_FAILED';
export const CERTIFICATES_DELETE_SUCCESS = 'CERTIFICATES_DELETE_SUCCESS';
export const CERTIFICATES_DELETE_RESET = 'CERTIFICATES_DELETE_RESET';
